import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService, TdLoadingService } from '@covalent/core';
import { Sale } from '../../../sales/sale';
import { SalesService } from '../../../sales/sales.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Branch } from '../../../accounting/branch';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-ship-order',
  templateUrl: './ship-order.component.html',
  styleUrls: ['./ship-order.component.scss']
})
export class ShipOrderComponent implements OnInit {
  prepared_orders: Sale[] = [];
  filtered_prepared_orders: Sale[] = [];

  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';

  constructor(private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _salesService: SalesService,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.getPreparedSalesOrders();

    // Then default to user's home branch
    this.branchFilter = this._authService.getUserBranches().find(b => { return b.id == this._authService.getHomeBranch() }).code;
    //Use this user's branches instead
    //this.allBranches$ = this._salesService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches()).do(o => { this.filter() });
  }

  getPreparedSalesOrders() {
    this._loadingService.register('loading');

    this._salesService.getSales().subscribe(
      response => {
        this.prepared_orders = response.filter(function (o) { return o.status == 'PREPARED' });

        this.filter();

        this._loadingService.resolve('loading');
      }
    );
  }

  goBack(): void {
    this.location.back();
  }

  searchOrders(): void {

  }

  filter(): void {
    let newData: Sale[] = this.prepared_orders;

    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['serve_from_branch_code'] == this.branchFilter || (d['branch_code'] == this.branchFilter && d['type'] == 'B2B') });
    } else {
      newData = newData.filter((d) => { return this._authService.getUserBranches().some(b => { return d.serve_from_branch_id == b.id }) })
    }


    this.filtered_prepared_orders = newData.sort((a, b) => { return (new Date(a.order_date).getTime()) - (new Date(b.order_date).getTime()) });
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/shipping/ship-order/ship-order.component.ts